'use client';

import Image from 'next/image';
import { cn } from '@/lib/utils';

interface ImageCardProps {
  src: string;
  alt: string;
  className?: string;
}

export function ImageCard({ src, alt, className }: ImageCardProps) {
  return (
    <div className={cn('relative rounded-3xl overflow-hidden w-full', className)}>
      <div className='relative w-full h-[270px] md:h-full md:aspect-auto'>
        <Image src={src} alt={alt} fill className='object-cover' priority />
        {/* Filtro sopra l'immagine */}
        <div className='absolute inset-0 bg-[#4444FF] opacity-30' />
      </div>
    </div>
  );
}
